import React from 'react';
import PropTypes from 'prop-types';

class TextAttribute extends React.Component {

  onChange = (event) => {
    this.props.onFieldValueChange(this.props.keyPath, event.target.value);
  };

  onFocus = () => {
    this.props.onFieldUIStateChange(this.props.keyPath, { touched: true, focused: true });
  };

  onBlur = () => {
    this.props.onFieldUIStateChange(this.props.keyPath, { focused: false, touched: true, hasLostFocusOnce: true });
  };

  render() {
    return this.props.include ? (
      <input
        id={this.props.id}
        aria-labelledby={this.props.labelledBy}
        type="text"
        className={`form-control ${this.props.className} ${this.props.invalid ? 'is-invalid' : ''}`}
        placeholder={this.props.placeholder}
        disabled={this.props.disabled}
        value={this.props.value}
        onChange={this.onChange}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
      />
    ) : null;
  }
}

TextAttribute.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string,
  invalid: PropTypes.bool,
  keyPath: PropTypes.array.isRequired,
  labelledBy: PropTypes.string,
  onFieldValueChange: PropTypes.func.isRequired,
  onFieldUIStateChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  include: PropTypes.bool,
};

TextAttribute.defaultProps = {
  className: '',
  disabled: false,
  id: 'temp',
  invalid: false,
  labelledBy: '',
  placeholder: '',
  value: '',
  include: true,
};

export default TextAttribute;
